import React from 'react';
import PropsTypes from 'prop-types';
import clsx from 'clsx';
import Icon from '@material-ui/core/Icon';
import { withStyles } from '@material-ui/core/styles';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Hidden from '@material-ui/core/Hidden';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import AnalyticsWrapper from '@configuratorware/configurator-frontendgui/App/Shared/Components/Analytics/AnalyticsWrapper';
import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { Button, Typography } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { areHintMessagesDisabled, getActiveHintMessage } from '../Reducers/HintMessages/Selectors';
import HintDialog from './HintDialog';
import { HintMessages } from '../../Enums';
import { jumpToNextHintMessage } from '../Reducers/HintMessages/Actions';

const styles = (theme) => ({
  iconHover: {
    margin: theme.spacing(1),
    textAlign: 'center',
    verticalAlign: 'middle',
    lineHeight: '24px',
    width: '24px',
    height: '24px',
    [theme.breakpoints.up('sm')]: {
      color: '#ffffff',
    },
    '&:hover': {
      opacity: 0.5,
      cursor: 'pointer',
    },
  },
  root: {
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
  },
  ToolbarButton: {
    padding: 0,
  },
  ToolbarIconButton: {
    height: 32,
    width: 32,
    padding: 8,
    '& span': {
      fontSize: 24,
      color: '#ffffff',
    },
  },
  MenuItemOption: {
    '@media (hover: none) , (pointer: coarse)': {
      '&:focus': {
        backgroundColor: '#fff',
      },
    },
  },
  toolTitle: {
    alignSelf: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 175,
  },
  backIcon: {
    paddingLeft: 10,
    [theme.breakpoints.up('sm')]: {
      color: '#ffffff',
    },
    '&:hover': {
      opacity: 0.5,
    },
  },
  backBtn: {
    display: 'flex',
    paddingLeft: 10,
    '&:hover': {
      opacity: 0.5,
      cursor: 'pointer',
    },
  },
  dialogTitleRoot: {
    padding: '12px 12px 20px',
    fontSize: '1.5rem',
    fontWeight: 400,
  },
  dialogContentRoot: {
    padding: '0 24px 24px 12px',
  },
  exitDialog: {
    borderTop: '7px solid ' + theme.palette.primary.main,
  },
  activeButton: {
    textTransform: 'none',
    whiteSpace: 'nowrap',
    padding: '4px 15px',
    backgroundColor: grey[900],
    color: 'white',
    textDecoration: 'none',
    '&:hover': {
      backgroundColor: grey[700],
    },
  },
  activeButtonLabel: {
    color: 'white',
  },
  TypographyCaption: {
    fontSize: 12,
    lineHeight: 1.7,
  },
});
const ITEM_HEIGHT = 52;

class CustomToolbarList extends React.Component {
  static propTypes = {
    classes: PropsTypes.object,
    tools: PropsTypes.array,
  };

  state = {
    anchorEl: null,
    showExitDialog: false,
  };
  anchorRef = React.createRef();

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  renderBackToOverviewButton = (tool) => {
    const { classes } = this.props;
    return (
      <AnalyticsWrapper key={tool.key} targetId={tool.key}>
        <div
          className={classes.backBtn}
          key={tool.key}
          onClick={() => this.setState({ showExitDialog: true })}
        >
          <Typography title={tool.title && t(tool.title)}>{t(tool.title)}</Typography>
          <Icon
            classes={{
              root: classes.backIcon,
            }}
          >
            chevron_left
          </Icon>
        </div>
      </AnalyticsWrapper>
    );
  };

  render() {
    const { classes, tools } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const toolbarMobileIcon = !open ? 'menu' : 'close';
    const activeHintMessage = getActiveHintMessage();

    return (
      <>
        <div className={clsx(classes.root, customClassName('tools'))}>
          {tools && (
            <Hidden xsDown>
              {tools.map((tool) =>
                tool.key === 'back' ? (
                  this.renderBackToOverviewButton(tool)
                ) : (
                  <AnalyticsWrapper key={tool.key} targetId={tool.key}>
                    <Icon
                      title={tool.title && t(tool.title)}
                      key={tool.key}
                      className={classes.iconHover}
                      onClick={tool.function}
                      ref={(ref) => {
                        if (tool.key === 'archive') {
                          this.anchorRef = ref;
                        }
                      }}
                    >
                      {tool.identifier}
                    </Icon>
                  </AnalyticsWrapper>
                )
              )}
              {/* LAN-32 Adding Hint Dialog */}
              {!areHintMessagesDisabled() &&
                activeHintMessage === HintMessages.SaveAndDownloadConfigurationButton && (
                  <HintDialog
                    offsetDirection={'left'}
                    anchorRef={this.anchorRef}
                    offset={10}
                    perpendicularOffset={-6}
                    title={t('hintMessages.hint6.title')}
                    content={t('hintMessages.hint6.content')}
                    onNextClick={() => Services.store.dispatch(jumpToNextHintMessage())}
                  />
                )}
            </Hidden>
          )}
          <Hidden smUp>
            <div>
              <IconButton
                aria-label="Menu"
                aria-haspopup="true"
                classes={{
                  root: classes.ToolbarButton,
                  label: classes.ToolbarIconButton,
                }}
                onClick={this.handleClick}
              >
                <Icon>{toolbarMobileIcon}</Icon>
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                onClose={this.handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 5.5,
                    width: 250,
                  },
                }}
              >
                {tools &&
                  tools.map((tool) => (
                    <MenuItem className={classes.MenuItemOption} key={tool.key} onClick={this.handleClose}>
                      {tool.key === 'back' ? (
                        this.renderBackToOverviewButton(tool)
                      ) : (
                        <AnalyticsWrapper key={tool.key} targetId={tool.key}>
                          <div style={{ display: 'flex', width: '100%' }} onClick={tool.function}>
                            <Icon key={tool.key} className={classes.iconHover}>
                              {tool.identifier}
                            </Icon>
                            <div className={classes.toolTitle}>{tool.title && t(tool.title)}</div>
                          </div>
                        </AnalyticsWrapper>
                      )}
                    </MenuItem>
                  ))}
              </Menu>
            </div>
          </Hidden>
        </div>
        <CustomDialog
          open={this.state.showExitDialog}
          onClose={() => this.setState({ showExitDialog: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          dialogTitle={t('exitDialog.title')}
          onCancel={() => this.setState({ showExitDialog: false })}
        >
          <DialogContent className={classes.dialogContentRoot}>
            <Typography
              variant="body1"
              classes={{ root: classes.TypographyCaption }}
              id="alert-dialog-description"
            >
              {t('exitDialog.content')}
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={() => this.setState({ showExitDialog: false })}>
              {t('exitDialog.cancel')}
            </Button>
            <MainButton
              variant="contained"
              onClick={() => window.parent.postMessage('go_back_to_overview', '*')}
              classes={{
                root: classes.activeButton,
                label: classes.activeButtonLabel,
              }}
            >
              {t('exitDialog.exit')}
            </MainButton>
          </DialogActions>
        </CustomDialog>
      </>
    );
  }
}

export default withStyles(styles, { name: 'CustomToolbarList' })(CustomToolbarList);
